import { render, staticRenderFns } from "./CmsIcmRoleAlloPre.vue?vue&type=template&id=2a68e4ab&scoped=true&"
import script from "./CmsIcmRoleAlloPre.vue?vue&type=script&lang=js&"
export * from "./CmsIcmRoleAlloPre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a68e4ab",
  null
  
)

export default component.exports